import React from 'react';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalContainer } from 'components/core';
import { withModalControlsHook, ModalComponentProps } from 'components/modals/with-modal-controls-hook';
import { VerifiedPhoneChangeModal } from './verified-phone-change-modal';

export type OnCloseResolvedValue = { confirmed: boolean };
export type OnOpenDataValue = undefined;

type VerifiedPhoneChangeModalWrapperProps = ModalComponentProps<OnOpenDataValue, OnCloseResolvedValue>;

const VerifiedPhoneChangeModalWrapper = ({
  onClose,
  containerProps,
}: VerifiedPhoneChangeModalWrapperProps): JSX.Element => (
  <ModalWrapper open>
    <ModalContainer width='500px' padding='24px' {...containerProps}>
      <VerifiedPhoneChangeModal onClose={onClose} />
    </ModalContainer>
  </ModalWrapper>
);

const [VerifiedPhoneChangeController, useVerifiedPhoneChangeModal] = withModalControlsHook<
  OnOpenDataValue,
  OnCloseResolvedValue
>(VerifiedPhoneChangeModalWrapper);

export { useVerifiedPhoneChangeModal, VerifiedPhoneChangeController as VerifiedPhoneChange };
